import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import './TopDestinationCarousel.css';
import { EffectCoverflow } from 'swiper/modules';
import { Link } from 'react-router-dom';

const TopDestinationCarousel = ({ destinations }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  return (
    <div className="top-destination-carousel-wrapper">
      <div className="destination-header">
        <div>
          <h4 className="destination-subheading">Top Destination</h4>
          <h2 className="destination-heading">Top Destination Of The Month</h2>
        </div>
        <div className="destination-tags">
          {destinations.map((d, i) => (
            <button
              key={i}
              className={`tag ${i === activeIndex ? 'active' : ''}`}
              onClick={() => swiperRef.current?.slideToLoop(i)}
            >
              {d.name}
            </button>
          ))}
        </div>
      </div>

      <Swiper
        modules={[EffectCoverflow]}
        effect="coverflow"
        centeredSlides={true}
        slidesPerView="auto"
        spaceBetween={100}
        loop={true}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 180,
          modifier: 2.5,
          slideShadows: false,
        }}
        className="top-destination-swiper"
      >
        {destinations.map((dest, i) => (
          <SwiperSlide key={i} className="swiper-slide-card">
            <div
              className="carousel-card"
              style={{
                backgroundImage: `linear-gradient(to top, #555, transparent), url(${dest.gallery[0]})`,
              }}
            >
              <div className="slide-info">
                <h3>{dest.name}</h3>
                <br></br>
                {/* <p>{dest.listings} Listing</p> */}
                
                <Link
                  to={`/destination/${dest.id}`}
                  className="view-btn"
                  style={{ textDecoration: 'none' }}
                >
                  View Details 
                </Link>

              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TopDestinationCarousel;
